<template>
    <b-modal
        ref="patientRelationshipDeleteModal"
        title-tag="h2"
        :title="title"
        lazy
    >
        {{ message }}

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isLoading && isProceed"
                variant="primary"
                @click="deleteRelationship"
            >
                Delete
            </b-button>
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import Client from "@/services/client";
import Appointments from "@/services/client-appointments";
import Relationships from "@/services/patient-relationships";
import Reminders from "@/services/client-reminders";
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    props: {
        patientId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isOpen: false,
            isLoading: false,
            isProceed: true,
            message: null,
            relation: null,
            type: null,
            title: "Delete Client (Patient) relationship"
        };
    },
    methods: {
        open(relation, type) {
            this.relation = relation;
            this.type = type;
            this.$refs.patientRelationshipDeleteModal.show();

            this.$nextTick(() => {
                if (this.type === "business") {
                    this.setMessage(0);
                } else {
                    this.getInfos();
                }
            });
        },
        async getInfos() {
            this.isLoading = true;
            if (this.type != "business") {
                let clientId = this.relation.actor_id;

                let appointments = await Appointments.getAppointments(
                    clientId,
                    { patient_id: this.patientId, type: 4, page: 1 }
                );
                let reminders = await Reminders.getFutureReminders({
                    client_id: clientId,
                    patient_id: this.patientId
                });
                let wellnessPlan = await Client.getWellnessPlanByPatient(
                    clientId,
                    this.patientId
                );

                // Handle Wellness Plan
                if (wellnessPlan.resource.length) {
                    let activePlan = _.find(wellnessPlan.resource, [
                        "status",
                        0
                    ]);
                    if (activePlan) {
                        this.setMessage(2);
                        this.isProceed = false;
                        this.isLoading = false;
                        return;
                    }
                }

                if (appointments && reminders && wellnessPlan) {
                    let activeAppointments = _.filter(
                        appointments.resource,
                        "is_active"
                    );

                    if (
                        activeAppointments.length > 0 ||
                        reminders.resources.length > 0
                    ) {
                        this.setMessage(1);
                    } else {
                        this.setMessage(0);
                    }
                }
            } else {
                this.setMessage(0);
            }

            this.isLoading = false;
        },
        setMessage(code) {
            switch (code) {
                case 1:
                    this.message =
                        "Deleting the relationship with the client will permanently delete all future appointments and reminders for this client. Do you want to delete the relationship?";
                    break;
                case 2:
                    this.title = "Can't Delete Relationship";
                    this.message =
                        "This client is responsible for one or more active wellness plans, and therefore this relationship cannot be deleted.  Please remove the active wellness plan(s) before deleting the relationship.";
                    break;
                default:
                    this.message =
                        "Are you sure you want to permanently delete this relationship?";
                    break;
            }

            this.isOpen = true;
        },
        close() {
            this.isLoading = false;
            this.$refs.patientRelationshipDeleteModal.hide();
        },
        deleteRelationship() {
            let params = {
                entity_id:
                    this.type === "business"
                        ? this.relation.business_id
                        : this.relation.actor_id,
                entity_type: this.type,
                relation_type: this.relation.relation_type.id,
                timestamp: this._now().toFormat("X")
            };

            this.isLoading = true;

            Relationships.deleteRelationship(this.patientId, params)
                .then(response => {
                    if (response.message.code === 200) {
                        this._message(response.resource);
                        this.$emit("reload");
                    } else {
                        this._message(
                            "Error : Unable to delete relationship",
                            "danger"
                        );
                    }

                    this.close();
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to delete relationship",
                        "danger"
                    );
                    this.close();
                    console.error(error);
                });
        }
    }
};
</script>
